export default {
    async setOnboardingEmail({commit}, email) {
        await commit('SET_EMAIL', email);
    }
}
